<div class="d-flex align-items-center avg-price">
   <span> {{price || 0}} </span>
    <span class="price_buybox-icon d-flex align-items-center" *ngIf="params.data.FulfilmentType === 'FBA'">
        <img src="../../../assets/images/amazon-icons/fba.svg" class="icon"   height="15" /> 
        <!-- <i class="fa fa-chevron-down" (mouseover)="openDialog($event)"  (mouseout)="closeDialog($event)"></i> -->
    </span>
</div>